import { Component, OnInit } from '@angular/core';
import { ContextSettingService } from '../context-setting.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-aggregate-options',
  templateUrl: './aggregate-options.component.html',
  styleUrls: ['./aggregate-options.component.css'],
})
export class AggregateOptionsComponent implements OnInit {
  constructor(private contextSettingService: ContextSettingService) { }
  
  useAggregation: boolean = true;
  aggregationTypesValue: string = "";
  aggregationFrequencyValue?: string;

  ngOnInit(): void {
    this.reset();
  }

  toggleAggregationOptions(aEvent: MatSlideToggleChange) {
    this.reset(!aEvent.checked);
  }

  setAggregationTypes() {
    this.contextSettingService?.setSetting('aggregation', this.aggregationTypesValue);
  }

  setAggregationFrequency() {
    this.contextSettingService?.setSetting('interval', this.aggregationFrequencyValue);
  }

  reset(useAggregation: boolean = true) {
    this.useAggregation = useAggregation;
    this.aggregationTypesValue = '';
    this.aggregationFrequencyValue = undefined;
    this.contextSettingService?.setSetting('aggregation', this.aggregationTypesValue);
    this.contextSettingService?.setSetting('interval', this.aggregationFrequencyValue);
  }
}
